const cancellation = {
  headerTitle: 'Submit Cancel Policy Request & Refund',
  cancelReason: 'Cancel reason',
  ibanNumber: 'IBAN Number',
  addNew: 'Add New',
  ibanPlaceholder: 'SA03 0000 0000 0000 0000 0000',
  confirmMobile: 'Confirm current mobile',
  confirmEmail: 'Confirm current email',
  documentsRequired: 'Documents required',
  chooseFile: 'Choose File',
  downloadTemplate: 'Download template',
  cancel: 'Cancel',
  submit: 'Submit',
  mobilePlaceholder: '05XXXXXXXX',
  emailPlaceholder: 'user@example.com',
  // Validation Messages
  validation: {
    reasonRequired: 'Cancellation reason is required',
    ibanRequired: 'IBAN number is required',
    ibanInvalid:
      'Invalid IBAN format. Must start with SA followed by 24 characters',
    mobileRequired: 'Confirmed mobile number is required',
    mobileInvalid:
      'Mobile number must start with 05 followed by 8 digits (English digits only)',
    emailRequired: 'Confirmed email is required',
    emailInvalid: 'Invalid email format',
    emailMax: 'Email address must not exceed 100 characters',
    documentsMin: 'Minimum 2 documents are required.',
    documentsMax: 'Maximum 5 documents are allowed.',
    fileRequired: 'Document is required',
    fileSize: 'File exceeds maximum size of 5MB',
    fileType: 'Invalid file type. Allowed types: PDF, JPG, JPEG, PNG',
  },
  fileDescription: 'Max size: 5MB. Formats: PDF, JPG, PNG.',
  // Upload Progress
  uploadStarting: 'Starting upload...',
  uploading: 'Uploading documents...',
  uploadComplete: 'Upload complete',
  cancelUpload: 'Cancel upload',
}

export default cancellation
